module.exports = __webpack_public_path__ + "static/cloud-visibility-poster-95f4448e9941e718b03ddd449064a88b.png";